/**
 * 🔐 ACCESS CONTROL CONFIGURATION
 *
 * Sistema de control acces pentru faza de testare cu familia și prietenii.
 * Această configurație restricționează înregistrarea doar la email-uri aprobate.
 */

// 🎯 TESTARE CONTROLATĂ - Email-uri aprobate pentru înregistrare
export const APPROVED_EMAILS = [
  // 👤 PROPRIETAR - Înlocuiește cu email-ul tău real
  "admin@example.com", // ← ÎNLOCUIEȘTE CU EMAIL-UL TĂU

  // 👥 FAMILIA - Adaugă email-urile familiei
  "family@example.com", // ← ÎNLOCUIEȘTE CU EMAIL-UL FAMILIEI

  // 👥 PRIETENI - Adaugă email-urile prietenilor pentru testare
  "friend1@example.com", // ← ÎNLOCUIEȘTE CU EMAIL REAL
  "friend2@example.com", // ← ÎNLOCUIEȘTE CU EMAIL REAL
  "friend3@example.com", // ← ÎNLOCUIEȘTE CU EMAIL REAL

  // 🧪 TESTARE & DEVELOPMENT
  "test@buzunarul.ro",
  "demo@buzunarul.ro",
] as const;

// 🛡️ ACCESS CONTROL MESSAGES
export const ACCESS_CONTROL = {
  REGISTRATION_RESTRICTED: "Înregistrarea este restricționată în timpul fazei de testare. Contactează administratorul pentru acces.",
  BETA_TESTING_NOTICE: "Aplicația este în faza de testare beta cu acces limitat.",
  CONTACT_ADMIN: "Pentru acces, contactează administratorul la admin@example.com", // ← ÎNLOCUIEȘTE CU EMAIL-UL TĂU
  APPROVED_DOMAINS: "Doar email-urile pre-aprobate pot crea conturi în această perioadă.",
} as const;

// 🎛️ DEPLOYMENT MODE CONTROL
export const DEPLOYMENT_CONFIG = {
  // 🚨 IMPORTANT: Setează FALSE pentru producție completă
  IS_BETA_TESTING: true,

  // 🔓 Când TRUE, permite înregistrarea liberă (pentru producție)
  ALLOW_OPEN_REGISTRATION: false,

  // 📧 Verifică dacă emailul este în whitelist
  isEmailApproved: (email: string): boolean => {
    if (!DEPLOYMENT_CONFIG.IS_BETA_TESTING) return true;

    const normalizedEmail = email.toLowerCase().trim();
    return APPROVED_EMAILS.some(approvedEmail =>
      approvedEmail.toLowerCase() === normalizedEmail
    );
  },

  // 🏠 Verifică dacă este domeniul proprietarului
  isOwnerDomain: (email: string): boolean => {
    const normalizedEmail = email.toLowerCase().trim();
    return normalizedEmail.endsWith('@buzunarul.ro');
  }
} as const;

// 🎨 UI CONTROL - Text pentru diferite stări
export const BETA_UI = {
  BETA_BADGE: "BETA",
  TESTING_PHASE: "Fază de testare",
  LIMITED_ACCESS: "Acces limitat",
  APPROVED_TESTERS: "Testeri aprobați",
} as const;
